import * as React from 'react';
import Modal from 'react-modal';
import TransferBlock from './TransferBlock';
import DatumContract from '../../helpers/datum.contract';
import PlasmaContract from '../../helpers/plasma.contract';
import web3Helper from '../../helpers/web3.helper';
import Header from './Header';
import * as css from './App.less';
import DatumNetworkContract from '../../helpers/datum-network.contract';

interface AppProps {
}

interface AppState {
  metaMaskStatus: number | null
  account?: string
  network: string
  web3: any
  balance?: number
  modalIsOpen: boolean
  isTransfer: boolean
  isLoaded: boolean
  error: string
}

export class App extends React.Component<AppProps, AppState> {
  appEl: any;
  datContract: DatumContract | DatumNetworkContract;
  plasmaContract: PlasmaContract;

  constructor(props: AppProps) {
    super(props);

    this.state = {
      metaMaskStatus: null,
      modalIsOpen: false,
      isTransfer: false,
      network: '',
      web3: null,
      error: '',
      isLoaded: false
    };
  }

  componentDidMount() {
    web3Helper.getStatus()
      .then(res => {
        this.setState({
          metaMaskStatus: res.status,
          account: res.account,
          modalIsOpen: res.status !== 2
        });
        if (res.status !== 2) {
          return;
        }
        return this.initContracts(res.web3);
      })
      .catch(console.error);
  }

  initContracts = (web3: any): Promise<any> => {
    return web3Helper.getNetwork()
      .then(network => {
        if (!network) {
          return;
        }
        if (network === 'datum-megatron' || network === 'datum') {
          this.datContract = new DatumNetworkContract(web3, network === 'datum');
        } else {
          this.datContract = new DatumContract(web3, network);
          this.plasmaContract = new PlasmaContract(web3, network);
        }
        this.setState({ network, web3 });
      });
  };

  // ToDo: add usage later
  initBalance() {
    const { account, web3 } = this.state;
    return this.datContract.balanceOf(account, web3)
      .then(balance => this.setState({ balance }))
      .catch(err => console.error(err));
  }

  toggleModal = () => {
    const { modalIsOpen } = this.state;
    this.setState({ modalIsOpen: !modalIsOpen, error: '' });
  };

  transfer = async (amount: number, address: string) => {
    const { network } = this.state;
    try {
      if (network === 'datum' || network === 'datum-megatron') {
        return (this.datContract as DatumNetworkContract).withdrawTx(address, amount);
      }
      const approved = await (this.datContract as DatumContract).approveTx(amount);
      // Delay to allow 2 MetaMask modals appear
      const success = await web3Helper.delay(approved);
      if (success) {
        return this.plasmaContract.depositTx(address, amount);
      }
    } catch (e) {
      this.setState({ modalIsOpen: true, error: e ? e.message : 'Some error occurred. Try again' });
    }
  };

  submitForm = (amount: number, address: string) => {
    const { metaMaskStatus, isTransfer } = this.state;
    const isValid = metaMaskStatus === 2;
    this.setState({ modalIsOpen: !isValid });

    if (!isValid || isTransfer) {
      return;
    }
    this.setState({ isTransfer: true });

    return this.transfer(Math.round(amount * 1e18), address)
      .then(() => this.setState({ isTransfer: false }))
      .catch(() => this.setState({ isTransfer: false }));
  };

  onError = (error: string) => {
    this.setState({ modalIsOpen: true, error });
  };

  renderModal() {
    const { metaMaskStatus } = this.state;
    switch (metaMaskStatus) {
      case 0:
        return (
          <div>
            <h3>Connect to MetaMask</h3>
            <p>Once you connected, reload the app</p>
            <button className={css.btnPrimary} onClick={this.toggleModal}>OK</button>
          </div>
        );
      case 1:
        return (
          <div>
            <h3>Auth with your MetaMask account</h3>
            <p>Once you authenticated, reload the app</p>
            <button className={css.btnPrimary} onClick={this.toggleModal}>OK</button>
          </div>
        );
      default:
        return (
          <div>
            <h3>Waiting for MetaMask</h3>
            <button className={css.btnPrimary} onClick={this.toggleModal}>OK</button>
          </div>
        );
    }
  }

  renderError(error: string) {
    return (
      <div>
        <h3>{error}</h3>
        <button className={css.btnPrimary} onClick={this.toggleModal}>OK</button>
      </div>
    );
  }

  render() {
    const {
      metaMaskStatus, account, modalIsOpen, isTransfer, error, network, balance
    } = this.state;
    return (
      <main className={css.main} ref={el => this.appEl = el}>
        <Header address={account} />
        <TransferBlock
          submit={this.submitForm}
          onError={this.onError}
          disabled={isTransfer || metaMaskStatus == null}
          network={network}
          balance={balance}
        />
        <Modal
          className={css.modal}
          isOpen={modalIsOpen}
          appElement={this.appEl}>
          { error ? this.renderError(error) : this.renderModal() }
        </Modal>
      </main>
    );
  }
}